export const STRATEGY_TYPES: Record<string, string> = {
    Acquisition: 'Acquisition',
    Awareness: 'Awareness',
    FixedOps: 'Fixed Ops',
    Inventory: 'Inventory',
    Static: 'Static',
} as const;
